<label
  [ngClass]="{
    'label-center': !input.value,
    'label-top': input.value,
    'disabled':disable
  }"
>
  {{ label }}
</label>
<span matAutocompleteOrigin #origin="matAutocompleteOrigin">
  <input
    #input="ngModel"
    #inputElement
    [(ngModel)]="value"
    (blur)="onTouch()"
    class="text-input"
    type="text"
    ngClass="{{ disable ? 'disabled' : '' }}"

    [matAutocompleteDisabled]="!matAutocomplete"
    [matAutocomplete]="matAutocomplete"
    [matAutocompleteConnectedTo]="origin"
    [ngStyle]="postIcon && { 'padding-right': '35px' }"
    [readonly]="readOnly"
  />

  <div
    *ngIf="postIcon"
    class="global-icon img"
    (click)="toggleSelect(inputElement)"
    [ngStyle]="{
      width: '24px',
      height: '24px',
      '-webkit-mask-image': 'url(' + postIcon + ')',
      'mask-image': 'url(' + postIcon + ')'
    }"
    aria-label="post icon"
  ></div>
</span>
